import type { Locale } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

const LOCALE_BY_LANGUAGE: Record<string, Locale> = {
  fr,
  en: enUS,
};

const DEFAULT_LOCALE: Locale = fr;

/**
 * date-fns locale matching the active i18next language, so formatted dates
 * follow the language the rest of the UI is rendered in.
 *
 * @returns the date-fns locale of the current language (French by default)
 */
export const useDateFnsLocale = (): Locale => {
  const { i18n } = useTranslation();
  const language = i18n.language.split('-')[0] ?? '';
  return LOCALE_BY_LANGUAGE[language] ?? DEFAULT_LOCALE;
};
